import React from "react";

export default function Dashboard() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 5.99967L8 1.33301L14 5.99967V13.333C14 13.6866 13.8595 14.0258 13.6095 14.2758C13.3594 14.5259 13.0203 14.6663 12.6667 14.6663H3.33333C2.97971 14.6663 2.64057 14.5259 2.39052 14.2758C2.14048 14.0258 2 13.6866 2 13.333V5.99967Z"
        stroke="#0C6980"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M6 14.6667V8H10V14.6667" stroke="#0C6980" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
